module.exports = __webpack_public_path__ + "static/media/header-logo.7e631068.svg";